import type { CallAdapter, CallAdapterMode } from './adapter'

export type {
  BackgroundOption,
  CallAdapter,
  CallAdapterMode,
  ConnectionQualityLevel,
  ConnectionStatus,
  ConnectOptions,
  DataHandler,
  DeviceKind,
  DisconnectReasonCode,
  LocalMediaFailure,
  LocalMediaFailureReason,
  LocalMediaKind,
  LocalPreview,
  MediaKind,
  ParticipantSnapshot,
  TrackSnapshot,
  TrackSource,
} from './adapter'
export type { ChatMessage, DataEnvelope, Reaction } from './data'
export {
  ChatMessageSchema,
  DataEnvelopeSchema,
  decodeEnvelope,
  encodeEnvelope,
  ReactionSchema,
} from './data'
export type { DeviceInfo } from './devices'
export {
  enumerateDevices,
  onDeviceChange,
  requestMediaPermissions,
  systemDefaultDeviceId,
} from './devices'
export { mediaFailureReason } from './media-failure'
// Статусный стор шумодава statически безопасен: сам фильтр (WASM + модель)
// уезжает в чанк только при реальном включении (dynamic import внутри).
export type { NoiseSuppressionStatus } from './noise-suppression'
export { noiseStatusStore } from './noise-suppression'
export { isIOS, supportsAudioOutputSelection, usesWebAudioMix } from './platform'
export { isBackgroundSupported } from './processors'
export type {
  CallStore,
  CallStoreActions,
  CallStoreApi,
  CallStoreState,
  LocalMediaState,
} from './store'
export { callStore } from './store'

// Реальный адаптер (и весь livekit-client за ним) грузится динамически —
// в mock-режиме тянется только fake, SDK в бандл не попадает.
export async function createCallAdapter(mode: CallAdapterMode): Promise<CallAdapter> {
  if (mode === 'fake') {
    const { FakeAdapter } = await import('./fake-adapter')
    return new FakeAdapter()
  }
  const { LiveKitAdapter } = await import('./livekit-adapter')
  return new LiveKitAdapter()
}
